import styled from 'styled-components';
import { Dialog } from 'components/Dialog';

export const StyledDownloadDialog = styled(Dialog)`
  width: 600px;
`;

export const StyledRadioComponent = styled.div`
  margin-top: 5px;
`;

export const StyledToast = styled.div`
  padding-bottom: 1em;
`;
